import { Row, Col, Modal, Form, Input, Tabs, Badge } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import languages from "../../config/language";
import { MAKE_URL } from "../../constants/conts";
import FileUpload from "../../components/FileUpload";
const { TabPane } = Tabs;

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                  =   Form.useForm();
  const { request }             =   useRequest();
  const [loading, setLoading]   =   useState(false);
  const [validationStatus, setValidationStatus] = useState({});
  const [image, setImage]       =   useState([]);
  const [initialImage, setInitialImage] = useState([]);
  const [imageChanged, setImageChanged] = useState(false);

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) return;

    const { image_url, ...otherData } = data;
    const mappedImages = Array.isArray(image_url) ? image_url.map((url) => ({ url, isExisting: true })) : [];
    
    form.setFieldsValue({
      ...otherData,
      file: mappedImages,
    });
    
    setImage(mappedImages);
    setInitialImage(mappedImages);
    setImageChanged(false);

  }, [data, form])
  
  const handleFieldChange = (data, lang, type) => {

    const name = form.getFieldValue(`${lang}_name`);

    setValidationStatus(prevStatus => ({
      ...prevStatus,
      [lang]: !!name
    }));
  }

  const handleFile = (data) => {
    setImage(data);
    setImageChanged(true);
    form.setFieldValue('file', data);
  }

  const onCreate = async (values) => {
    setLoading(true);
    
    try {
      const formData = new FormData();

      languages.forEach((lang) => {
        const value = values[`${lang.short}_name`];
        if (value) {
          formData.append(`${lang.short}_name`, value);
        }
      });

      if (imageChanged && Array.isArray(image)) {
        for (const f of image) {
          if (f.originFileObj) {
            formData.append("files[]", f.originFileObj);
          } else if (f.url) {
            const response  =   await fetch(f.url);
            const blob      =   await response.blob();
            const fileName  =   f.name || f.url.split("/").pop() || "file";
            formData.append("files[]", blob, fileName);
          }
        }
      }

      request({
        url: MAKE_URL(path, data),
        method: 'POST',
        data: formData,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            setImage([]);
            setInitialImage([]);
            setImageChanged(false);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error.response.data.message, Severty.ERROR);
        },
      });
    } catch (error) {
      setLoading(false);
      ShowToast("Error processing files", Severty.ERROR);
    }
  };

  useEffect(() => {
    const initialValidationStatus = {};
    
    languages.forEach(lang => {
        initialValidationStatus[lang.short] = !!form.getFieldValue(`${lang.short}_name`);
    });

    setValidationStatus(initialValidationStatus);
  }, [])

  const handleCancel = () => {
    setImage([]);
    setInitialImage([]);
    setImageChanged(false);
    hide();
  };

  return (
    <Modal
      open = {show}
      title = {`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText = "Ok"
      onCancel = {handleCancel}
      okButtonProps = {{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        
        <Row gutter={[16, 16]}>
          
          <Col span={24} xs={12} sm={12} md={24}>
            
           <Tabs defaultActiveKey={languages[0].short}>
              
              {languages.map(lang => (

                <TabPane tab={<span>{lang.long} {validationStatus[lang.short] === false && <Badge dot color="red" />}</span>} key={lang.short}>

                  <Form.Item label={`Name (${lang.long})`} name={`${lang.short}_name`}
                    rules={[
                      ...(lang.short === 'en' ? [
                        { required: true, message: `Please enter the name in ${lang.long}!` }
                      ] : []),
                      { max: 100, message: "Name should not contain more than 100 characters!" },
                      { min: 2, message: "Name should contain at least 2 characters!" },
                    ]}
                    onChange={(data) => handleFieldChange(data, lang.short, 'title')}
                  >

                    <Input autoComplete="off" placeholder={`Enter name in ${lang.long}`} />

                  </Form.Item>
                </TabPane>
              ))}
            </Tabs>
          </Col>

          <Col span={24} xs={24} sm={24} md={24}>
            <Form.Item 
              label="Upload Image/Video"
              valuePropName="value" 
              name="file"
            >
              <FileUpload filterType={["image", "video"]} btnName={'Image/Video'} onChange={(data) => handleFile(data)} multiple maxCount={5} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
};

export default From;